import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { ApplicationElement } from './application_element.js';

import  { VERSION } from '../version.js';

import { styles as sharedStyles } from '../styles/shared-styles'

import '@shoelace-style/shoelace/dist/components/card/card.js';
import { map } from 'lit/directives/map.js';

import { requestPersistedStorage } from '../lib/utils.js';

@customElement('app-info')
export class AppInfo extends ApplicationElement {
  static styles = [
    sharedStyles,
    css`
      .permission {
        font-size: var(--sl-font-size-large);
        display: flex;
        align-items: center;
        margin-bottom: var(--sl-spacing-large);
        border-bottom: 1px solid var(--sl-color-gray-300);
        padding-bottom: var(--sl-spacing-large);

        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
          margin-bottom: 0;
        }
      }

      .permission i {
        margin-right: 10px;
      }

    `
  ]

  @property({ type: Object }) permissions: any = new Map();
  @property({ type: Object }) config = this.state?.config;

  // Static config for App info
  @property({ type: Object }) appConfig: any = {
    version: VERSION
  };

  get userData() {
    return this.config.without('key', 'event');
  }



  onStateChange({ state }) {
    this.config = state.config;
  }



  async getPermission(name: PermissionName) {
    let granted = false;

    // iOS fallback for checking persistent storage
    if(name === 'persistent-storage') {
      granted = await navigator.storage.persisted()
    } else {
      const { state } = await navigator.permissions.query({ name });
      granted = state === 'granted'
    }

    this.permissions.set(name, granted);
    this.requestUpdate();
  }

  connectedCallback(): void {
    super.connectedCallback();
    this.getPermission('persistent-storage' as PermissionName);
  }

  renderPermission(item) {
    const [name, granted] = item;

    return html`
      <article class="permission">
        <i class=${granted ? 'bi-check-circle' : 'bi-x-circle'}></i>
        <span>${name}</span>
      </article>
    `;
  }

  renderConfig(obj, key) {
    return html`
      <dl>
        <dt>${key}</dt>
        <dd>${obj[key]}</dd>
      </dl>
    `;
  }

  renderConfigs(data) {
    return html`
      ${Object.keys(data).map(key => this.renderConfig(data, key))}
    `;
  }

  render() {
    return html`
      <app-header enableBack title="About"></app-header>
      <main>

        <section class="hero">
        <sl-avatar
          style="--size: 64px;"
          image="/assets/icons/maskable_icon_x192.png"
          label="FastingFlux logo"
        ></sl-avatar>
          <h2>FastingFlux</h2>
          <p>Made with ❤️ by Effectiva studio Ltd.</p>
        </section>

        <h2 class="section-title">Permissions</h2>
        <section class="card" @click=${() => requestPersistedStorage()}>
          ${map(this.permissions, (key) => this.renderPermission(key))}
        </section>

        <h2 class="section-title">App</h2>
        <section class="card">
          ${this.renderConfigs(this.appConfig)}
        </section>
      </main>
    `;
  }
}
